export const removeAt = <T>(entities: T[], idx: number): Array<T> => [...entities.slice(0, idx), ...entities.slice(idx + 1)];
